import axios from 'axios'
import { camelizeKeys } from 'humps'

export function loginTestChiletrabajos(params) {
  return axios.post('/api/v1/company/login_chiletrabajos', params)
    .then(res => res.data);
}

export function saveCredentials(params) {
  return axios.post('/api/v1/integrations/int_companies/create', params)
    .then(res => camelizeKeys(res.data));
}

export function getIntConfigs() {
  return axios.get('/api/v1/integrations/int_companies')
    .then(res => camelizeKeys(res.data));
}

export function createOrUpdateIntSelectionProcess(processId, intCompanyId, offer, portal, noticeType = null) {
  return axios.post('/api/v1/integrations/int_selection_processes/create_or_update',
    {
      'selection_process_id': processId,
      'int_company_id': intCompanyId,
      'json_process_external': offer,
      'portal': portal,
      'laborum_plan_id': noticeType?.laborumPlanId || null,
      'laborum_plan_name': noticeType?.laborumPlanName || null,
    },
  )
    .then(res => camelizeKeys(res.data));
}

export function savePostLink(params) {
  return axios.patch('/api/v1/integrations/int_selection_processes/set_offer', params)
    .then(res => camelizeKeys(res.data));
}

export function laborumPostLinkTest(params) {
  return axios.post('/api/v1/company/laborum_api/check_job_postings', params)
    .then(res => camelizeKeys(res.data));
}

export function chiletrabajosPostLinkTest(params) {
  return axios.post('/api/v1/company/check_offer_chiletrabajos', params)
    .then(res => camelizeKeys(res.data));
}

export function changeIntCompaniesState(params) {
  return axios.patch('/api/v1/integrations/int_companies/change_state', params)
    .then(res => camelizeKeys(res.data));
}

export function editCredentials(params) {
  return axios.patch('/api/v1/integrations/int_companies/edit', params)
    .then(res => camelizeKeys(res.data));
}

export function getIntProcess(params) {
  return axios.post('/api/v1/integrations/int_selection_processes/get_int_process',
    { 'selection_process_id': params.processId, 'int_company_id': params.intCompanyId })
    .then(res => camelizeKeys(res));
}

export function getIntSelectionProcess(processId, intCompanyId) {
  return axios.post('/api/v1/integrations/int_selection_processes/get_int_process',
    { 'selection_process_id': processId, 'int_company_id': intCompanyId })
    .then(res => camelizeKeys(res.data));
}

export function publishLaborumOffer(processId, intCompanyIdLaborum) {
  return axios.post('/api/v1/company/laborum_api/activate_offer',
    { 'selection_process_id': processId, 'int_company_id': intCompanyIdLaborum })
    .then(res => camelizeKeys(res))
}

export function publishTrabajandoOfferV2(processId, intCompanyIdTrabajando) {
  return axios.post('/api/v1/company/trabajando_api_activate_offer_v2',
    { 'selection_process_id': processId, 'int_company_id': intCompanyIdTrabajando })
    .then(res => camelizeKeys(res));
}

export function publishChiletrabajosOffer(processId, intCompanyIdChiletrabajos) {
  return axios.post('/api/v1/company/publish_chiletrabajos',
    { 'selection_process_id': processId, 'int_company_id': intCompanyIdChiletrabajos })
    .then(res => camelizeKeys(res));
}

export function bnePostLinkTest(params) {
  return axios.post('/api/v1/company/check_offer_bne', params)
    .then(res => camelizeKeys(res.data));
}

export function publishBneOffer(processId) {
  return axios.post('/api/v1/company/publish_bne',
    { 'selection_process_id': processId })
    .then(res => camelizeKeys(res));
}

export function deactivateBneOffer(processId) {
  return axios.patch('/api/v1/company/deactivate_bne',
    { 'selection_process_id': processId })
    .then(res => camelizeKeys(res.data));
}

export function reactivateBneOffer(processId) {
  return axios.patch('/api/v1/company/reactivate_bne',
    { 'selection_process_id': processId })
    .then(res => camelizeKeys(res.data));
}

export function createUniqueCard(params) {
  return axios.post('/api/v1/integrations/unique_card/create', params)
    .then(res => camelizeKeys(res.data));
}

export function getUniqueCard(params) {
  return axios.post('/api/v1/integrations/unique_card/get', params)
    .then(res => camelizeKeys(res.data));
}

export function setLinkedinId(params) {
  return axios.post('/api/v1/integrations/set_linkedin_id', params)
    .then(res => camelizeKeys(res.data));
}

export function editLinkedinId(params) {
  return axios.patch('/api/v1/integrations/change_linkedin_id', params)
    .then(res => camelizeKeys(res.data));
}

export function changeLinkedinStatus(params) {
  return axios.patch('/api/v1/integrations/change_linkedin_status', params)
    .then(res => camelizeKeys(res.data));
}

export function requestLaborumToken() {
  return axios.post('/api/v1/company/laborum_api/send_emails')
    .then(res => camelizeKeys(res.data));
}

export function getAdvertisementTypeList() {
  return axios.get('/api/v1/company/laborum_api/advertisement_type_list')
    .then(res => camelizeKeys(res.data));
}

export function loginBne(params) {
  return axios.post('/api/v1/company/login_bne', params, { skipErrorToast: true })
    .then(res => camelizeKeys(res.data))
}

// Backend envuelve doble: envelope ATS `{is_success, data: payload}` y el controller
// pone `payload = { data: form_fields }` donde `form_fields` es un JSON string (se
// cachea serializado en Redis). De ahí el `payload.data` + `JSON.parse`.
export function getBneFormFields() {
  return axios.get('/api/v1/company/form_fields', { skipErrorToast: true })
    .then(res => {
      const { is_success, data: payload } = res.data || {}
      if (!is_success || !payload?.data) return null
      return camelizeKeys(JSON.parse(payload.data))
    })
}
